import React from "react";
import { Route, Switch } from "react-router-dom";

import Cancel from "./components/Cancel";
import Company from "./components/Company";
import User from "./components/User";

import styles from "./SignUp.css";

export default () => (
  <div className={styles.root}>
    <Switch>
      <Route component={User} path="/signup" exact />
      <Route component={Company} path="/signup/account" />
      <Route component={Cancel} path="/signup/cancel" />
    </Switch>
  </div>
);
